import { Menu } from "lucide-react";

import { SECTION_TYPES } from "@/lib/constants/sections";

const navbarSection = {
  type: SECTION_TYPES.NAVBAR,
  content: {},
  meta: {
    displayName: "Navbar",
    displayDescription: "The navigation bar at the top of the page.",
    displayIcon: Menu,
    variantsCount: 5,
  },
};

export default navbarSection;
